import DocsSettingsForm from '@/app/timesheet/_components/form/DocsSettingsForm';
import { ResourceHistory } from '@/components/resource-history';
import { Sidebar } from '@/components/sidebar';
import OwnershipStructureForm from '../../OwnershipStructureForm';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** Ownership, history and HR document settings drawers. */
export default function CompanyFormSidebars() {
  const {
    canManageDocsSettings,
    companyId,
    docsSettingsOpen,
    existingSignature,
    form,
    historyOpen,
    isEdited,
    isProfile,
    onClose,
    onDocsSettingsClose,
    onHistoryClose,
    onOwnerFinish,
    open,
    ownershipStructureState,
    ownershipStructureValues,
    signatureKey,
    t,
  } = useCompanyGeneralDataForm();

  return (
    <>
      {ownershipStructureState?.visible && (
        <Sidebar
          title={t('ownershipStructure', { ns: 'forms' })}
          open={open}
          onClose={onClose}
        >
          {({ onScroll }) => (
            <OwnershipStructureForm
              formData={ownershipStructureValues}
              onClose={onClose}
              onScroll={onScroll}
              onSubmit={onOwnerFinish}
              companyId={companyId}
              existingSignature={existingSignature}
              existingSignatureKey={signatureKey}
              onSignatureSave={(signatureData) => {
                form.setFieldValue(
                  ['authorizedRepresentatives', 'signature'],
                  signatureData
                );
              }}
            />
          )}
        </Sidebar>
      )}

      {/* History Sidebar (the profile has a History tile instead) */}
      {isEdited && companyId && !isProfile && (
        <Sidebar
          open={historyOpen}
          onClose={onHistoryClose}
          title={t('history', { ns: 'forms' })}
          placement="right"
          className="max-w-xl"
        >
          <ResourceHistory modelName="Company" documentId={companyId} />
        </Sidebar>
      )}

      {/* Docs Settings Sidebar — on the profile the same form is the
          "Document templates" tile, so the drawer is not mounted. */}
      {companyId && canManageDocsSettings && !isProfile && (
        <Sidebar
          open={docsSettingsOpen}
          onClose={onDocsSettingsClose}
          title={t('additionalDocsSettings', { ns: 'forms' })}
          placement="right"
          className="max-w-2xl"
        >
          <DocsSettingsForm
            companyId={companyId}
            isEdited={isEdited}
            onClose={onDocsSettingsClose}
          />
        </Sidebar>
      )}
    </>
  );
}
